module.exports = __webpack_public_path__ + "img/logo-full.59da4bce.png";